import { getDynDataOne, createGuid, getObject } from "./general_functions";
import $ from "jquery";
import language from "./translation";

export const btiLevel = (objs) => {

    var levels = [];
    const colors = ["blue", "green", "yellow", "red"];

    objs.forEach((obj) => {

        let meta = obj.meta;
        let content = obj.obj;


        const title = getDynDataOne(meta, "b6353dc6-0199-4dc8-98f7-bb691fc86ce9", "localId").value;
        const text = getDynDataOne(meta, "3ef3c298-5c8a-46d3-8341-28e10567aeae", "localId").value;

        //var num = title.replace(/[^0-9]/g, '');
        //let level = parseInt(num, 10);


        // console.log("Meta Level", meta);

        levels.push(`   <div class="col-lg-3 col-md-3 col-sm-6">
                            <a class="bti__level__button align-top ${colors[title]}" href="#" data-level="${title}" title="${title}" data-color="blue">
                                <span class="bti__level__ball ${colors[title]}"></span>
                                <h2 class="bti__level__title">Nivå ${title}</h2>
                                <p class="bti__level__text">${text}</p>
                            </a>
                        </div>
                        <div id="mobile__steps__${title}" class="bti__stepsmobile bti__stepsmobile__${title} bti__content d-sm-none col">
                        </div>
                        `);

    })

    levels = levels.join("");


    var html = $(`  <div class="bti__level">
                        <div class="row justify-content-center row-eq-height">
    
                        ${levels}
                            
                        </div>
                    </div>`);



    return html;

}

export const btiStep = (objs, contenthtml = false) => {

    var steps = [];
    const colors = ["blue", "green", "yellow", "red"];

    // console.log(objs);

    objs.forEach((obj) => {

        let meta = obj.meta;
        let content = obj.obj;

        const title = getDynDataOne(meta, "2590e7de-06ab-4c46-9c20-b97c8cc327a1", "localId").value;
        const level = getDynDataOne(meta, "d60245ac-bf40-4a77-b83a-7c0e6a4edb5b", "localId").value;
        const step = getDynDataOne(meta, "20a57290-522b-4d23-803c-e7d6af92489a", "localId").value;
        const who = getDynDataOne(meta, "a4213774-6d38-4ab5-9981-cd6b4bec0019", "localId").value;
        let how = getDynDataOne(meta, "b3490587-85f4-47d9-be8c-0ef592612d09", "localId");
        if (how)
            how = how.value;
        const what = getDynDataOne(meta, "dd0cdc54-e8a1-415e-94a4-d34894c2749e", "localId").value;
        const tools = decodeURIComponent(content.contentObject);

        //var num = tmpLevel.replace(/[^0-9]/g, '');
        //let level = parseInt(num, 10);

        let files = [];

        if (content.relatedSubscriberContents) {
            files = content.relatedSubscriberContents;
        }

        if (files.length < 1) {
            files = false;
        }

        // console.log(content.relatedSubscriberContents);

        // console.log("files", files, content.relatedSubscriberContents)

        // console.log(content, files)

        // files = "%5B%7B%22type%22:%22mal_visittkort%22,%22relations%22:%5B%5D%7D,%7B%22type%22:%22mal_blokk%22,%22relations%22:%5B%5D%7D,%7B%22type%22:%22mal_enhetsmal%22,%22relations%22:%5B%5D%7D,%7B%22type%22:%22mal_beredskap%22,%22relations%22:%5B%5D%7D,%7B%22type%22:%22mal_media%22,%22relations%22:%5B%7B%22title%22:%22Kontaktliste-hjelpetjenester%22,%22contentId%22:%22617eed7b-a642-44d7-8c7c-8c0cd9713d42%22%7D,%7B%22title%22:%22Oppmelding-tverrfaglig-team-barnehage%22,%22contentId%22:%22a5469f42-7e3d-4c19-ae5d-6915a5b03125%22%7D,%7B%22title%22:%22Rutine-tverrfaglig-team-barnehage%22,%22contentId%22:%225cf56b2c-f5ac-4a3b-b9dc-ff01ede5e21c%22%7D,%7B%22title%22:%22Samtykkeerklaring-tverrfaglig-samarbeid%22,%22contentId%22:%22fa2724d1-dfd8-4d91-8d17-7e66ca2e41f5%22%7D,%7B%22title%22:%22Tiltaksoversikt%22,%22contentId%22:%22bf3c00e7-24b9-466e-a1b7-6ff310b8a566%22%7D%5D%7D%5D";

        const fileGuid = createGuid();

        let stepsHtml = `
        
        <div class="bti__step ${colors[level]}" data-level="${level}" data-filesloaded="false" data-files="${files}" data-filesid="files_${fileGuid}" data-step="${step}" data-id="${obj.contentId}" data-author="${obj.creator}">
            <div class="row">
                <div class="col-12">
                    <a href="#" class="bti__step__header  ${colors[level]}">
                        <span class="bti__step__nr text-center">${step}</span>
                        <span class="bti__step__icon"><span class="budlight-arrow-bottom"></span></span>
                        <h3 class="bti__step__headertext">${title}</h3>
                    </a>
                </div>
            </div>
            <div class="bti__step__content">
                <div class="row">
                    <div class="col-md-12">
                        ${ who && `
                            <dl>
                                <dt>${language("BTI_WHO")}</dt>
                                <dd>
                                    ${who}
                                </dd>
                            </dl>`
                        }
                        ${ what && `
                            <dl>
                                <dt>${language("BTI_WHAT")}</dt>
                                <dd>
                                    ${what}
                                </dd>
                            </dl>`
                        }
                        ${ how && `
                            <dl>
                                <dt>${language("BTI_HOW")}</dt>
                                <dd>
                                    ${how}
                                </dd>
                            </dl>`
                        }

                        <p class="tools">
                        
                            ${tools}
                            <ul class="files_${fileGuid}" >
                                <div class="spinner-border" role="status" id="files__loading__spinner">
                                  <span class="sr-only">Loading...</span>
                                </div>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        `;

        steps.push(stepsHtml);


        // console.log("#mobile__steps__" + level, $("#mobile__steps__" + level).length);
        if (contenthtml) {
            contenthtml.find("#mobile__steps__" + level).append(stepsHtml);
        }
        // return "";


    })

    const html = steps.join("");

    return html;

}

export const btiClickActions = () => {



    $("body").on("click", ".bti__level__button", function(e) {
        e.preventDefault();
        // console.log("Lever");

        let level = $(this).data("level");
        $(".bti__level__button").removeClass("active");
        $(this).addClass("active");

        $(".bti__stepsmobile").removeClass("active");
        $(".bti__stepsmobile__" + level).addClass("active");


        $(".bti__step").hide();
        $(`.bti__step[data-level=${level}]`).show();
        $(`.bti__step[data-level=${level}]`).show();

        $(".bti__content").removeClass("red blue yellow green");

        if ($(this).hasClass("red")) {
            $(".bti__content").addClass("red")
        }
        if ($(this).hasClass("blue")) {
            $(".bti__content").addClass("blue")
        }
        if ($(this).hasClass("yellow")) {
            $(".bti__content").addClass("yellow")
        }
        if ($(this).hasClass("green")) {
            $(".bti__content").addClass("green")
        }

    })

    $("body").on("click", ".bti__step__header", function(e) {
        e.preventDefault();
        $(".bti__step__header").removeClass("active");

        const parent = $(this).parents(".bti__step");

        $(this).addClass("active");
        parent.find(".bti__step__content").toggle();

        const fileid = parent.data("filesid");

        // console.log("test 1");

        if (!parent.data("filesloaded")) {

            // console.log("test 2", parent.data("files"));

            if (parent.data("files") !== "null") {
                const files = JSON.parse(decodeURIComponent(parent.data("files")));
                let filesloaded = parent.data("filesloaded");


                if (files && filesloaded === false) {

                    // console.log("test 3");
                    files.forEach((obj) => {

                        // console.log("test x");
                        // 
                        if (obj.type === "mal_media") {

                            if (obj.relations) {

                                const count__relations = obj.relations.length;
                                let count__relations__done = 0;

                                // console.log(count__relations);

                                obj.relations.forEach((file) => {

                                    // console.log("file",file, fileid);


                                    getObject(file.contentId, function(data) {

                                        // console.log("done", $("#" + fileid).length, $("#" + fileid));

                                        // $("#" + fileid).append("TEST");

                                        $("." + fileid).append(`<li><a href="${data.path}" target=_blank>${data.filename} (${data.extension})</a></li>`);




                                        count__relations__done++;

                                        // console.log(count__relations__done, count__relations);


                                        if (count__relations__done >= count__relations) {

                                            // console.log("ok");

                                            parent.data("filesloaded", "true");

                                            $("." + fileid).find("#files__loading__spinner").remove();
                                        }

                                    })


                                })


                            }
                        }

                    })
                }
                else {

                    // console.warn("Ingen filer funnet");
                    $("." + fileid).find("#files__loading__spinner").remove();
                    $("#" + fileid).html("");
                }


            } // noe files null 
            else {
                $("." + fileid).find("#files__loading__spinner").remove();
            }

            $(this).attr("data-filesloaded", "true");
        }
        else {
            $("." + fileid).find("#files__loading__spinner").remove();
        }

    });

}
